import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconButtonModule } from '../icon-buttons/icon-button.module';
import { FileDropDirective } from './file-drop.directive';
import { FileSelectDirective } from './file-select.directive';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
    imports: [
        CommonModule,
        IconButtonModule
    ],
    declarations: [
        FileDropDirective,
        FileSelectDirective,
        FileUploadComponent
    ],
    exports: [FileUploadComponent]
})
export class AttachmentsModule {
}
